module.exports = __webpack_public_path__ + "static/media/carret_down.e0a523ea.svg";